import { PlusOutlined, RedoOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { getListProduct } from 'api/product/product.api';
import {
  ButtonBreadcrumb,
  ButtonTextIcon,
  LineVertical,
} from 'components/Button';
import Breadcrumb from 'components/Layout/ApplicationLayout/Breadcrumb';
import HeaderListDataLayout from 'components/Layout/HeaderListDataLayout';
import LayoutDefault from 'components/Layout/LayoutDefault';
import Pagination from 'components/Pagination';
import { REGISTER_PATH } from 'constant/appPath';
import {
  defaultPageSizeOptions,
  defaultSelectPageSizeOption,
} from 'constant/Pagination/pageSizeOption';
import { SORT_DIRECTION } from 'constant/sortConstants';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import useSearchKeyword from 'hook/useSearchKeyword';
import useSetTitlePage from 'hook/useSetTitlePage';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { network } from 'recoil/atom/network';
import TableProduct from './component/TableProduct';

const listItemSA = [
  {
    title: <Link to={'/'}>企業管理</Link>,
  },
  {
    title: 'プロダクト管理',
  },
];

const ProductList = () => {
  useSetTitlePage('プロダクト管理 | Soliton パートナーサイト', true);

  const location = useLocation();
  const { searchKeywordState } = location.state || {};
  const [messageErrorNetWork, contextErrorNetWork] = message.useMessage();
  const isOnline = useRecoilValue(network);
  const { searchKeyword, setSearchKeyword, onSearch, emptyText } =
    useSearchKeyword();
  const [page, setPage] = useState(10);
  const [current, setCurrent] = useState(1);
  const { useQueryAPI } = useCustomQuery();
  const [searchValue, setSearchValue] = useState('');
  const [sortedInfo, setSortedInfo] = useState({});
  const navigate = useNavigate();
  const errorNetWork = () => {
    messageErrorNetWork
      .open({
        type: 'error',
        content:
          '問題が発生しました。インターネット接続を確認して、もう一度やり直してください。',
      })
      .then();
  };
  const handleNavigate = () => {
    if (isOnline) {
      navigate(`${REGISTER_PATH}`);
    } else {
      errorNetWork();
    }
  };

  const handleChangePageSize = (value) => {
    if (isOnline) {
      setPage(value);
      setCurrent(1);
    } else {
      errorNetWork();
    }
  };

  const handleChange = (pagination, filters, sorter) => {
    if (isOnline) {
      setSortedInfo({
        sortField: sorter.order && sorter.field,
        sortDirection: sorter.order && SORT_DIRECTION[sorter.order],
        order: sorter.order,
        columnKey: sorter.columnKey,
      });
    } else {
      errorNetWork();
    }
  };

  const handlePagingChange = (pageNumber, pageSize) => {
    if (isOnline) {
      setCurrent(pageNumber);
      setPage(pageSize);
    } else {
      errorNetWork();
    }
  };

  const { data: listProduct = [], isLoading } = useQueryAPI({
    api: getListProduct,
    key: 'productList',
    params: {
      pageNumber: current,
      pageSize: page,
      keyword: searchKeyword,
      displayedDateFrom: '',
      displayedDateTo: '',
      category: '',
      status: '',
      sortField: sortedInfo?.sortField ?? '',
      sortDirection: sortedInfo?.sortDirection ?? '',
    },
  });

  const handleResetData = () => {
    setPage(10);
    setCurrent(1);
    setSearchValue('');
    setSearchKeyword('');
    setSortedInfo({});
  };

  useEffect(() => {
    if (searchKeyword) {
      setCurrent(1);
      setSortedInfo({});
    }
  }, [searchKeyword]);

  useEffect(() => {
    setSearchKeyword(searchKeywordState ?? '');
    setSearchValue(searchKeywordState ?? '');
    const updatedState = {
      searchKeywordState: '',
    };
    navigate(location.pathname, { state: updatedState, replace: true });
  }, []);

  return (
    <>
      {contextErrorNetWork}
      <Breadcrumb listItem={listItemSA} titlePage="プロダクト管理">
        <ButtonBreadcrumb
          text={'新規登録'}
          icon={<PlusOutlined />}
          onClick={handleNavigate}
        />
      </Breadcrumb>
      <LayoutDefault>
        <HeaderListDataLayout
          titleScreen={'プロダクト一覧'}
          searchPlaceholder={'プロダクト名、カテゴリ名、を検索します。'}
          onSearch={onSearch}
          loading={isLoading}
          value={page}
          handleChangePageSize={handleChangePageSize}
          pageSizeOptions={defaultSelectPageSizeOption}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        >
          <ButtonTextIcon
            text={'リフレッシュ'}
            icon={<RedoOutlined />}
            onClick={handleResetData}
          />
          <LineVertical />
        </HeaderListDataLayout>
        <TableProduct
          errorNetWork={errorNetWork}
          isLoading={isLoading}
          dataRaw={listProduct.data}
          emptyText={emptyText}
          sortedInfo={sortedInfo}
          onChange={handleChange}
          searchKeyword={searchKeyword}
        />
        <Pagination
          totalTitle={'プロダクト総数'}
          currentPage={current}
          pageSize={page}
          handlePagingChange={handlePagingChange}
          total={listProduct.data?.total}
          pageSizeOptions={defaultPageSizeOptions}
          handleChangePageSize={handleChangePageSize}
        />
      </LayoutDefault>
    </>
  );
};

export default ProductList;
